import useInvalidateDiaries from "@/features/diaries/features/edit/api/invalidateDiaries";
import { supabaseClient } from "@/lib/supabase";
import type { Education } from "@/types/database/events";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export async function upsertEducation(educationData: Education["Insert"]) {
	const { data, error } = await supabaseClient
		.from("educations")
		.upsert(educationData)
		.select()
		.single();
	if (error) throw error;
	return data;
}

interface EducationMutation {
	diaryId: string;
}

export const useEducationMutation = ({ diaryId }: EducationMutation) => {
	const invalidateDiaries = useInvalidateDiaries();

	return useMutation({
		mutationKey: ["upsert-education"],
		mutationFn: async (data: Education["Insert"]) => {
			return await upsertEducation(data);
		},
		onError: () => {
			toast.error("Error creating new education");
		},
		onSuccess: (mutation) => {
			toast.success("Education saved");

			if (mutation?.onSuccess) {
				mutation.onSuccess();
			}
		},
		onSettled: () => {
			invalidateDiaries(diaryId);
		},
	});
};
